import React from 'react';
import { marked } from 'marked';
import i18next from 'i18next';
import { Repeat } from '../../../StyledComponents/Repeat';
import { Image } from '../../../StyledComponents/Image';
import { UtilityTextBold } from '../../../StyledComponents/Utility';
import Modal from '../../../StyledComponents/Modal';
import Content from '../../../StyledComponents/Content';
import LogoBox from '../../../StyledComponents/LogoBox';
import { Accessory } from '../../../@types/codegen/types';
import { numberSeparator } from '../../../utils/formats';
import { imageWithWidth } from '../../../utils/image';
import PriceBox from '../../../StyledComponents/PriceBox';
import { Link } from '../../../StyledComponents/Link';

interface AccesoryModalProps {
  accessory: Accessory;
  onClose: () => void;
}

const AccesoryModal = ({ accessory, onClose }: AccesoryModalProps) => {
  const priceList = [
    {
      label: i18next.t('item.accessories.price'),
      price: `${numberSeparator(accessory.price)} ${i18next.t('currency.default')}`,
      oldPrice: false,
    },
  ];

  if (accessory.salePrice) {
    priceList.push({
      label: i18next.t('item.accessories.oldPrice'),
      price: `${numberSeparator(accessory.salePrice)} ${i18next.t('currency.default')}`,
      oldPrice: true,
    });
  }

  if (accessory.assemblyPrice) {
    priceList.push({
      label: i18next.t('item.accessories.installationCost'),
      price: `${numberSeparator(accessory.assemblyPrice)} ${i18next.t('currency.default')}`,
      oldPrice: false,
    });
  }

  return (
    <Modal title={accessory.name} onClose={onClose}>
      {accessory.images?.[0] && (
        <Repeat>
          <Image src={imageWithWidth(accessory.images[0], 632)} alt={accessory.name} />
        </Repeat>
      )}
      {accessory.logotype && (
        <Repeat>
          <LogoBox
            logo={`${accessory.logotype}?w=160`}
            logo2x={`${accessory.logotype}?w=320`}
            alt={accessory.manufacturer || i18next.t('common.logotype') || ''}
            wide
          />
        </Repeat>
      )}
      <Repeat>
        <PriceBox prices={priceList} />
      </Repeat>

      <Repeat>
        <Content dangerouslySetInnerHTML={{ __html: marked(accessory.description) }} />
      </Repeat>
      {accessory.articleNumber && (
        <Repeat>
          <UtilityTextBold as="div">
            {i18next.t('item.accessories.articleNumberShort')}
          </UtilityTextBold>
          <div>{accessory.articleNumber}</div>
        </Repeat>
      )}
      {accessory.productPage && accessory.productPage.url && (
        <Repeat>
          <Link
            href={accessory.productPage.url}
            title={
              i18next.t('item.accessories.moreInformationAboutAccessory', {
                accessory: accessory.name,
              }) || ''
            }
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            {accessory.productPage.title || i18next.t('common.readMore')} (
            {i18next.t('common.opensInNewTab')})
          </Link>
        </Repeat>
      )}
    </Modal>
  );
};

export default AccesoryModal;
